import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=4fa5e8f6"
import script from "./MaintenancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=4fa5e8f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip});
